"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Link = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _index = require("../../styles/index.js");
var _styledComponents = _interopRequireWildcard(require("../../styled-components.js"));
var _excluded = ["component", "isActive", "isHover", "isFocus", "isUsingKeyboard", "useBrowserDefaultFocusStyle"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var transitionColor = _index.durationMedium;
var NavPillListItemLink = /*#__PURE__*/_react["default"].forwardRef(function NavPillListItemLink(_ref, ref) {
  var Component = _ref.component,
    isActive = _ref.isActive,
    isHover = _ref.isHover,
    isFocus = _ref.isFocus,
    isUsingKeyboard = _ref.isUsingKeyboard,
    useBrowserDefaultFocusStyle = _ref.useBrowserDefaultFocusStyle,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(Component, Object.assign({}, props, {
    ref: ref
  }));
});
var activeStyles = (0, _styledComponents.css)(["background-color:", ";color:", ";"], (0, _index.cssColorValue)(_index.semanticColors.backgroundTintedBase), (0, _index.cssColorValue)(_index.semanticColors.textBase));
var focusStyles = (0, _styledComponents.css)(["", " ", " padding-block-end:0;&::after{color:", ";inline-size:calc(100% - ", ");}"], _index.browserFocusReset, (0, _index.focusBottomBorder)(_index.focusBorderWidth, true, true), _index.focusBorderColor, (0, _index.cssControlSize)('smaller', '32px'));
var focusSelectedStyles = (0, _styledComponents.css)(["position:relative;", " &::after{", " content:'';border-radius:", ";border:", "px solid ", ";}"], _index.browserFocusReset, (0, _index.absoluteBorder)(), _index.borderRadiusRounded, _index.focusBorderWidth, _index.focusBorderColor);
var getFocusStyles = function getFocusStyles(_ref2) {
  var isActive = _ref2.isActive,
    isUsingKeyboard = _ref2.isUsingKeyboard,
    useBrowserDefaultFocusStyle = _ref2.useBrowserDefaultFocusStyle;
  if (!isUsingKeyboard || useBrowserDefaultFocusStyle) return null;
  if (isActive) return focusSelectedStyles;
  return focusStyles;
};
var hoverStyles = (0, _styledComponents.css)(["color:", ";"], (0, _index.cssColorValue)(_index.semanticColors.textBase));
var disabledStyles = (0, _styledComponents.css)(["color:", ";cursor:not-allowed;pointer-events:none;opacity:", ";"], (0, _index.cssColorValue)(_index.semanticColors.textSubdued), _index.opacityDisabled);

// eslint-disable-next-line prefer-arrow-callback
var Link = exports.Link = (0, _styledComponents["default"])(NavPillListItemLink).withConfig({
  displayName: "Link",
  componentId: "sc-nmmha9-0"
})(["", ";color:", ";border-radius:", ";display:flex;align-items:center;padding-block:", ";min-block-size:", ";padding-inline:", ";transition:", " color linear;text-decoration:none;", ";&:hover{", "}", " &[disabled],&[aria-disabled=\"true\"]{", "}", " &:not(:active){", "}&:active{", " ", "}", " &:focus{&:not(:active){", "}&:active{", "}}"], (0, _index.rootStyle)(), (0, _index.cssColorValue)(_index.semanticColors.textSubdued), (0, _index.cssBorderRadius)('larger-3', '16px'), (0, _index.cssSpacing)('tighter-4', _index.controlPaddingBlock.sm), (0, _index.cssControlSize)('smaller', _index.controlSizeFallback.small), (0, _index.cssSpacing)('base', '16px'), transitionColor, (0, _index.overflowWrapFlexText)(), hoverStyles, function (props) {
  return props.isHover && hoverStyles;
}, disabledStyles, function (props) {
  return props.isActive && (0, _styledComponents.css)(["&,&:hover{", "}"], activeStyles);
}, function (_ref3) {
  var isFocus = _ref3.isFocus,
    isActive = _ref3.isActive,
    useBrowserDefaultFocusStyle = _ref3.useBrowserDefaultFocusStyle;
  return isFocus && !useBrowserDefaultFocusStyle && getFocusStyles({
    isActive: isActive,
    isUsingKeyboard: true,
    useBrowserDefaultFocusStyle: false
  });
}, activeStyles, function (_ref4) {
  var isFocus = _ref4.isFocus,
    useBrowserDefaultFocusStyle = _ref4.useBrowserDefaultFocusStyle;
  return isFocus && !useBrowserDefaultFocusStyle && getFocusStyles({
    isActive: true,
    isUsingKeyboard: true,
    useBrowserDefaultFocusStyle: false
  });
}, function (_ref5) {
  var useBrowserDefaultFocusStyle = _ref5.useBrowserDefaultFocusStyle;
  return !useBrowserDefaultFocusStyle && _index.browserFocusReset;
}, function (_ref6) {
  var isActive = _ref6.isActive,
    isUsingKeyboard = _ref6.isUsingKeyboard,
    useBrowserDefaultFocusStyle = _ref6.useBrowserDefaultFocusStyle;
  return getFocusStyles({
    isActive: isActive,
    isUsingKeyboard: isUsingKeyboard,
    useBrowserDefaultFocusStyle: useBrowserDefaultFocusStyle
  });
}, function (_ref7) {
  var isUsingKeyboard = _ref7.isUsingKeyboard,
    useBrowserDefaultFocusStyle = _ref7.useBrowserDefaultFocusStyle;
  return getFocusStyles({
    isActive: true,
    isUsingKeyboard: isUsingKeyboard,
    useBrowserDefaultFocusStyle: useBrowserDefaultFocusStyle
  });
});